export default "__VITE_ASSET__DyNMd_14__"